module.exports = __webpack_public_path__ + "img/reminder-documents.ad907405.svg";